import { NgModule } from '@angular/core';
import { MatButtonModule } from '@angular/material/button';
import { MatCheckboxModule } from '@angular/material/checkbox';
import { MatDialogModule } from '@angular/material/dialog';
import { MatIconModule } from '@angular/material/icon';
import { MatInputModule } from '@angular/material/input';
import { MatProgressSpinnerModule } from '@angular/material/progress-spinner';
import { MatToolbarModule } from '@angular/material/toolbar';
import { MatTooltipModule } from '@angular/material/tooltip';
import { FuseSharedModule } from '@fuse/shared.module';
import { TranslateModule } from '@ngx-translate/core';
import { LinkGroupsComponent } from './link-groups/link-groups.component';
import { LinkedGroupsComponent } from './linked-groups/linked-groups.component';
import { TabGroupComponent } from './tab-groups.component';

@NgModule({
  entryComponents: [
    LinkGroupsComponent
  ],
  declarations: [
    TabGroupComponent,
    LinkGroupsComponent,
    LinkedGroupsComponent
  ],
  imports: [
    TranslateModule,

    MatIconModule,
    MatInputModule,
    MatDialogModule,
    MatButtonModule,
    MatToolbarModule,
    FuseSharedModule,
    MatTooltipModule,
    MatCheckboxModule,
    MatProgressSpinnerModule
  ],
  exports: [
    TabGroupComponent
  ]
})
export class TabGroupModule { }
